import SectionBox from '@components/SectionBox';
import { useEffect, useState } from 'react';

export default function TabsSectionBox(props: { sections: unknown[], locale: string, labels: string[] }) {
  const { sections, locale, labels } = props;

  const [ activeTab, setActiveTab ] = useState(labels[0]);
  const [ sectionBoxIndex, setSectionBoxIndex ] = useState(0);

  useEffect(() => {
    setSectionBoxIndex(labels.findIndex((label) => label === activeTab));
  }, [ activeTab, labels ]);

  return (
    <>
      <div className='relative w-full overflow-x-auto pb-2 pt-4 md:pt-7 px-4'>
        <div className='flex gap-2 md:gap-4 justify-start md:justify-center min-w-fit mx-auto flex-wrap'>
          {labels.map((label) => (
            <button
              key={ label }
              onClick={ () => setActiveTab(label) }
              className={ `
                whitespace-nowrap
                px-4 md:px-6
                py-2 md:py-2.5
                text-sm md:text-base
                transition-all duration-200
                min-w-[100px] md:min-w-[140px]
                rounded-full
                ${ activeTab === label
              ? 'bg-primary text-white font-medium shadow-sm'
              : 'bg-gray-50 text-primary-800 hover:bg-gray-100 hover:text-primary-600 border border-primary-800 hover:border-primary-600'
            }
              ` }
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <SectionBox
        sections={ sections[sectionBoxIndex] }
        locale={ locale }
      />
    </>
  );
}
